import classNames from "classnames";
import { MouseEvent } from "react";

import { CFC } from "shared/types";

type Props = {
  head?: boolean;
  colSpan?: number;
  rowSpan?: number;
  onClick?: (e: MouseEvent<HTMLTableCellElement>) => void;
}

export const Col: CFC<Props> = ({
  head = false,
  colSpan,
  rowSpan,
  onClick,
  children,
  className,
}) => {
  return (
    <>
      {head && (
        <th
          colSpan={colSpan}
          rowSpan={rowSpan}
          className={classNames("p-3 text-left bg-gray-50 text-black-500", className)}
          onClick={onClick}
        >
          {children}
        </th>
      )}
      {!head && (
        <td
          colSpan={colSpan}
          rowSpan={rowSpan}
          className={classNames("p-3", className)}
          onClick={onClick}
        >
          {children}
        </td>
      )}
    </>
  );
};
